export class Documents {
    file:File;
}